import { render } from "./document.mobile.vue?vue&type=template&id=4b38d892&ts=true"
import script from "./document.mobile.vue?vue&type=script&scoped=true&lang=ts"
export * from "./document.mobile.vue?vue&type=script&scoped=true&lang=ts"

import "./document.mobile.vue?vue&type=style&index=0&id=4b38d892&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__